export default "__VITE_ASSET__BInEzPUT__"